export class AppVoData {
	public id: number;
	public type: string;

	constructor(id: number, type: string) {
		this.id = id;
		this.type = type;
	}
}


// WEBPACK FOOTER //
// ./src/app/app-vo-data.ts